import styled from 'styled-components';

type Themed = { theme: { colors?: Record<string, string> } };

const surface = ({ theme: { colors = {} } }: Themed) => colors.surface ?? '#0E0F18';
const border = ({ theme: { colors = {} } }: Themed) => colors.outlineVariant ?? 'rgba(255,255,255,0.12)';
const onSurface = ({ theme: { colors = {} } }: Themed) => colors.onSurface ?? '#E6E7EE';
const muted = ({ theme: { colors = {} } }: Themed) => colors.onSurfaceVariant ?? 'rgba(230,231,238,0.66)';
const error = ({ theme: { colors = {} } }: Themed) => colors.error ?? '#FFB4AB';

export const SandboxRoot = styled.div`
  position: relative;
  width: 100%;
  height: 100%;
  min-height: 0;
`;

/** White behind the page, as a browser tab would be: most pages assume it. */
export const SandboxFrame = styled.iframe`
  display: block;
  width: 100%;
  height: 100%;
  border: none;
  background: #fff;
`;

export const SandboxLoading = styled.div`
  position: absolute;
  inset: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  pointer-events: none;
`;

export const SandboxPanel = styled.div`
  position: absolute;
  left: 12px;
  right: 12px;
  bottom: 12px;
  z-index: 2;
  display: flex;
  flex-direction: column;
  gap: 8px;
  max-height: 40%;
  padding: 10px 12px;
  border-radius: 10px;
  border: 1px solid ${border};
  background: ${surface};
  box-shadow: 0 8px 24px rgba(0, 0, 0, 0.24);
  font-size: 12.5px;
  color: ${onSurface};
`;

export const SandboxPanelHead = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
`;

export const SandboxPanelTitle = styled.span`
  flex: 1 1 auto;
  min-width: 0;
  font-weight: 600;
  color: ${error};
`;

export const SandboxNotice = styled(SandboxPanelTitle)`
  color: ${muted};
  font-weight: 500;
`;

export const SandboxErrorList = styled.ul`
  margin: 0;
  padding: 0 0 0 16px;
  overflow-y: auto;
  min-height: 0;
  font-family: ui-monospace, SFMono-Regular, Menlo, monospace;
  font-size: 11.5px;
  color: ${muted};
  overflow-wrap: anywhere;
`;
